import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './SupplierPhoneNumberField.module.scss';

export const SupplierPhoneNumberField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<FullInfoField
			label="supplierPhoneNumberLabel"
			value={restaurantForFullInfo?.supplier?.phone}
			containerClassName={style.container}
		/>
	);
};
